// extracted by mini-css-extract-plugin
module.exports = {"airportLabel":"AirportsFilter-module__airportLabel___lfqYJ","airportName":"AirportsFilter-module__airportName___Ya4jd"};